import React, { useEffect, useState } from "react";
import AppMenu from "../components/AppMenu";
import { title } from "../config";
import { getSiteData } from "../services/siteAPI";
import moment from "moment";
import { getSSLExpiringSites } from "../services/siteAPI";
import { getDomainExpiringSites } from "../services/siteAPI";
import { useToast } from "../components/ToastContext";
import "../assets/css/Home.css";

const Home = () => {
  const { showToast } = useToast();
  const [total, setTotal] = useState(0);
  const [errorCount, setErrorCount] = useState(0);
  const [runningCount, setRunningCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [sslExpiryCounts, setSslExpiryCounts] = useState({
    ssl15: 0,
    ssl30: 0,
    ssl45: 0,
    ssl60: 0,
  });
  const [domainExpiryCounts, setDomainExpiryCounts] = useState({
    domain15: 0,
    domain30: 0,
    domain45: 0,
    domain60: 0,
  });
  const [memoryFull, setMemoryFull] = useState({
    mem80per: 0,
    mem75per: 0,
  });

  const createCustomObject = (customObj, keyObj, extraKey, keyName) => {
    if (keyObj === "") {
      keyObj = "NA";
    }
    if (customObj[keyObj]) {
      customObj[keyObj].count += 1;
    } else {
      customObj[keyObj] = {
        count: 1,
        [extraKey]: keyName ? keyName : "NA",
      };
    }
  };

  const updateVersionCount = (versionObj, version, updatedDate, domain) => {
    if (version === "") {
      version = "NA";
    }
    if (versionObj[version]) {
      versionObj[version].count += 1;
    } else {
      versionObj[version] = {
        count: 1,
        date: updatedDate ? updatedDate : "NA",
      };
    }
  };
  const countFieldValues = ((value, countMap) => {
    if (value) {
      if (countMap.hasOwnProperty(value)) {
        countMap[value]++;
      } else {
        countMap[value] = 1;
      }
    }
  }
  );
  const getFreeSpace = (free, size) => {
    const percentageFull = ((size - free) / size) * 100;
    const roundValue = Math.round(percentageFull);
    return roundValue;
  };
  useEffect(() => {
    reloadSite();
  }, []);
  const reloadSite = async () => {
    let temp = await getSiteData(showToast);

    let errorCount = 0;
    let runningCount = 0;

    let domain15 = 0;
    let domain30 = 0;
    let domain45 = 0;
    let domain60 = 0;

    try {
      const [exp15, exp30, exp45, exp60] = await Promise.all([
        getDomainExpiringSites(15, showToast),
        getDomainExpiringSites(30, showToast),
        getDomainExpiringSites(45, showToast),
        getDomainExpiringSites(60, showToast),
      ]);

      setDomainExpiryCounts({
        domain15: exp15.length,
        domain30: exp30.length,
        domain45: exp45.length,
        domain60: exp60.length,
      });
    } catch (err) {
      console.error("Error fetching Domain expiry data:", err);
    }

    let ssl15 = 0;
    let ssl30 = 0;
    let ssl45 = 0;
    let ssl60 = 0;

    try {
      const [exp15, exp30, exp45, exp60] = await Promise.all([
        getSSLExpiringSites(15, showToast),
        getSSLExpiringSites(30, showToast),
        getSSLExpiringSites(45, showToast),
        getSSLExpiringSites(60, showToast),
      ]);

      setSslExpiryCounts({
        ssl15: exp15.length,
        ssl30: exp30.length,
        ssl45: exp45.length,
        ssl60: exp60.length,
      });
    } catch (err) {
      console.error("Error fetching SSL expiry data:", err);
    }

    setLoader(false);

    let activeCount = 0;
    let memoryLowCount = 0;
    let memory75PerCount = 0;

    const versionCount = {};

    const pm2ErrorDiffcount = {};
    const pm2OutDiffcount = {};
    const nodeVcount = {};
    const regionCount = {};
    const redisKeyCountObj = {};

    temp.forEach((site) => {
      const {
        active,
        status,
        runningStatus,
        version,
        sslExpiry,
        domainExpiry,
        free,
        size,
        diffPM2ErrSize,
        node_version,
        region,
        date,
        name,
        redisKeyCount,
        diffPM2OutSize,
      } = site;

      if (runningStatus === true) {
        runningCount++;
      } else if (runningStatus === false) {
        errorCount++;
      }

      if (active == 1) {
        activeCount++;

        updateVersionCount(versionCount, version, date);

        if (status === "error") {
          errorCount++;
        }

        const expiry = moment(sslExpiry, moment.ISO_8601, true);

        if (expiry.isValid()) {
          const now = moment();
          if (expiry.isSameOrBefore(moment(now).add(15, "days"))) ssl15++;
          if (expiry.isSameOrBefore(moment(now).add(30, "days"))) ssl30++;
          if (expiry.isSameOrBefore(moment(now).add(45, "days"))) ssl45++;
          if (expiry.isSameOrBefore(moment(now).add(60, "days"))) ssl60++;
        }

        if (domainExpiry) {
          const domainExpiryDate = moment(domainExpiry, moment.ISO_8601, true);
          if (domainExpiryDate.isValid()) {
            const now = moment();
            if (domainExpiryDate.isSameOrBefore(now.add(15, "days"))) domain15++;
            if (domainExpiryDate.isSameOrBefore(now.add(30, "days"))) domain30++;
            if (domainExpiryDate.isSameOrBefore(now.add(45, "days"))) domain45++;
            if (domainExpiryDate.isSameOrBefore(now.add(60, "days"))) domain60++;
          }
        }

        if (getFreeSpace(free, size) > 80) {
          memoryLowCount++;
        }
        if (getFreeSpace(free, size) > 75) {
          memory75PerCount++;
        }
      }

      if (diffPM2ErrSize >= 0) {
        createCustomObject(pm2ErrorDiffcount, diffPM2ErrSize, "name", name);
      }

      if (diffPM2OutSize >= 0) {
        createCustomObject(pm2OutDiffcount, diffPM2OutSize, "name", name);
      }

      if (node_version) {
        countFieldValues(node_version, nodeVcount);
      }

      if (region) {
        countFieldValues(region, regionCount);
      }

      if (redisKeyCount) {
        createCustomObject(redisKeyCountObj, redisKeyCount, "name", name);
      }
    });


    setTotal(temp.length);
    setMemoryFull({
      mem80per: memoryLowCount,
      mem75per: memory75PerCount
    });
    setRunningCount(runningCount);
    setErrorCount(errorCount);

  };
  return (
    <div className="dashboard-container">
      <div className="px-2 sticky-header">
        <h3 className="m-0 p-2">{title} | Home</h3>
        <AppMenu />
      </div>

      {loader ? (
        <div className="dashboard-loader">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="container-fluid py-3">
          <div className="row g-3 mb-3">
            <div className="col-md-4 col-sm-12">
              <div className="alert alert-primary dashboard-card">
                <h5 className="fw-semibold text-primary">All Sites</h5>
                <p className="mb-0 text-dark">
                  <a className="dashboard-link text-primary" href="/site" rel="noreferrer">
                    Total:{" "}
                    {total}
                  </a>
                </p>
              </div>
            </div>

            <div className="col-md-4 col-sm-12">
              <div className="alert alert-success dashboard-card">
                <h5 className="fw-semibold text-success">Running Sites</h5>
                <p className="mb-0 text-dark">
                  <a className="dashboard-link text-success" href="/sites/runningStatus/true" rel="noreferrer">
                    Running:{" "}
                    {runningCount}
                  </a>
                </p>
              </div>
            </div>

            <div className="col-md-4 col-sm-12">
              <div className="alert alert-danger dashboard-card">
                <h5 className="fw-semibold text-danger">Error Sites</h5>
                <p className="mb-0 text-dark">
                  <a className="dashboard-link text-danger" href="/sites/runningStatus/false" rel="noreferrer">
                    Errors:{" "}
                    {errorCount}
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-md-3 col-sm-12">
              <div className="alert alert-warning dashboard-card">
                <strong className="text-secondory">SSL Expiry</strong>
                <div className="mt-2 small">
                  <div className={sslExpiryCounts?.ssl15 > 0 ? "ssl15-count" : ""}>
                    <a className="dashboard-link" href="/sites/expiry/15" rel="noreferrer">
                      {sslExpiryCounts?.ssl15}
                      {" "}
                      sites expiring in <strong>15 days</strong>.
                    </a>
                  </div>

                  <div className={sslExpiryCounts?.ssl30 > 0 ? "ssl30-count" : ""}>
                    <a className="dashboard-link" href="/sites/expiry/30" rel="noreferrer">
                      {sslExpiryCounts?.ssl30}
                      {" "}
                      sites expiring in <strong>30 days</strong>.
                    </a>
                  </div>

                  <div className={sslExpiryCounts?.ssl45 > 0 ? "ssl45-count" : ""}>
                    <a className="dashboard-link" href="/sites/expiry/45" rel="noreferrer">
                      {sslExpiryCounts?.ssl45}
                      {" "}
                      sites expiring in <strong>45 days</strong>.
                    </a>
                  </div>

                  <div className={sslExpiryCounts?.ssl60 > 0 ? "ssl60-count" : ""}>
                    <a className="dashboard-link" href="/sites/expiry/60" rel="noreferrer">
                      {sslExpiryCounts?.ssl60}
                      {" "}
                      sites expiring in <strong>60 days</strong>.
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3 col-sm-12">
              <div className="alert alert-warning dashboard-card">
                <strong className="text-secondory">Domain Expiry</strong>
                <div className="mt-2 small">
                  <div className={domainExpiryCounts?.domain15 > 0 ? "domain15-count" : ""}>
                    <a className="dashboard-link" href="/sites/domain-expiry/15" rel="noreferrer">
                      {domainExpiryCounts?.domain15}
                      {" "}
                      domains expiring in <strong>15 days</strong>.
                    </a>
                  </div>

                  <div className={domainExpiryCounts?.domain30 > 0 ? "domain30-count" : ""}>
                    <a className="dashboard-link" href="/sites/domain-expiry/30" rel="noreferrer">
                      {domainExpiryCounts?.domain30}
                      {" "}
                      domains expiring in <strong>30 days</strong>.
                    </a>
                  </div>

                  <div className={domainExpiryCounts?.domain45 > 0 ? "domain45-count" : ""}>
                    <a className="dashboard-link" href="/sites/domain-expiry/45" rel="noreferrer">
                      {domainExpiryCounts?.domain45}
                      {" "}
                      domains expiring in <strong>45 days</strong>.
                    </a>
                  </div>

                  <div className={domainExpiryCounts?.domain60 > 0 ? "domain60-count" : ""}>
                    <a className="dashboard-link" href="/sites/domain-expiry/60" rel="noreferrer">
                      {domainExpiryCounts?.domain60}
                      {" "}
                      domains expiring in <strong>60 days</strong>.
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3 col-sm-12">
              <div className="alert alert-danger memory-card">
                Memory 80% full on{" "}
                <a className="dashboard-link text-danger" href="sites/free/80" rel="noreferrer">
                  {memoryFull?.mem80per}
                  {" "}
                  Sites.
                </a>
              </div>
            </div>

            <div className="col-md-3 col-sm-12">
              <div className="alert alert-warning memory-card">
                Memory 75% full on{" "}
                <a className="dashboard-link text-warning" href="sites/free/75" rel="noreferrer">
                  {memoryFull?.mem75per}
                  {" "}
                  Sites.
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>


  );
};
export default Home;
